import { render, staticRenderFns } from "./NotificationAppBar.vue?vue&type=template&id=565bbd2a"
import script from "./NotificationAppBar.vue?vue&type=script&lang=js"
export * from "./NotificationAppBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports